export default {
  // Common
  common: {
    welcome: 'Добро пожаловать',
    loading: 'Загрузка...',
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    edit: 'Редактировать',
    search: 'Поиск...',
    filter: 'Фильтр',
    export: 'Экспорт',
    refresh: 'Обновить',
    back: 'Назад',
    next: 'Далее',
    previous: 'Назад',
    confirm: 'Подтвердить',
    yes: 'Да',
    no: 'Нет',
    close: 'Закрыть',
    actions: 'Действия',
    status: 'Статус',
    active: 'Активный',
    inactive: 'Неактивный',
    enabled: 'Включён',
    disabled: 'Отключён',
    success: 'Успех',
    error: 'Ошибка',
    warning: 'Предупреждение',
    info: 'Информация',
    apply: 'Применить',
    download: 'Скачать',
    upload: 'Загрузить',
    view: 'Просмотр',
    details: 'Детали',
    name: 'Имя',
    email: 'Email',
    phone: 'Телефон',
    address: 'Адрес',
    country: 'Страна',
    city: 'Город',
    state: 'Регион',
    zipCode: 'Почтовый индекс',
    createdAt: 'Дата создания',
    updatedAt: 'Дата обновления',
    description: 'Описание',
    type: 'Тип',
    amount: 'Сумма',
    date: 'Дата',
    time: 'Время',
    from: 'От',
    to: 'До',
    all: 'Все',
    none: 'Нет',
    select: 'Выбрать',
    selected: 'Выбрано',
    total: 'Итого',
    subtotal: 'Промежуточный итог',
    pending: 'Ожидание',
    approved: 'Одобрено',
    rejected: 'Отклонено',
    completed: 'Завершено',
    failed: 'Ошибка',
    processing: 'Обработка',
    cancelled: 'Отменено',
    required: 'Обязательно',
    optional: 'Необязательно',
    today: 'Сегодня',
    yesterday: 'Вчера',
    thisWeek: 'Эта неделя',
    thisMonth: 'Этот месяц',
    lastMonth: 'Прошлый месяц',
    custom: 'Произвольно',
    range: 'Диапазон',
    noData: 'Нет данных',
    noResults: 'Результаты не найдены',
    showMore: 'Показать больше',
    showLess: 'Показать меньше',
    expand: 'Развернуть',
    collapse: 'Свернуть',
    clearAll: 'Очистить всё',
    selectAll: 'Выбрать все',
    deselectAll: 'Снять выбор',
    copyToClipboard: 'Копировать в буфер обмена',
    copied: 'Скопировано!',
    notAvailable: 'Н/Д',
    upgrade: 'Обновить',
  },

  // Auth
  auth: {
    login: 'Войти',
    logout: 'Выйти',
    email: 'Email',
    password: 'Пароль',
    rememberMe: 'Запомнить меня',
    forgotPassword: 'Забыли пароль?',
    signIn: 'Войти',
    signUp: 'Зарегистрироваться',
    loginSuccess: 'Вход выполнен успешно',
    loginError: 'Неверный email или пароль',
    sessionExpired: 'Сессия истекла. Пожалуйста, войдите снова.',
    adminPanel: 'Панель администратора',
    needHelp: 'Нужна помощь?',
    poweredBy: 'Работает на',
  },

  // Navigation
  nav: {
    dashboard: 'Панель управления',
    instruments: 'Инструменты',
    clients: 'Клиенты',
    accounts: 'Счета',
    trading: 'Торговля',
    reports: 'Отчёты',
    auditLog: 'Журнал аудита',
    withdrawals: 'Вывод средств',
    deposits: 'Пополнения',
    settings: 'Настройки',
    plugins: 'Плагины',
    accountGroups: 'Группы счетов',
    kyc: 'KYC',
    apiDocs: 'Документация API',
    notifications: 'Уведомления',
    upgrade: 'Обновить',
    groupPricing: 'Ценообразование групп',
  },

  // Dashboard
  dashboard: {
    title: 'Панель управления',
    overview: 'Обзор',
    stats: 'Статистика',
    totalClients: 'Всего клиентов',
    totalAccounts: 'Всего счетов',
    openPositions: 'Открытые позиции',
    todayPnL: 'П&У сегодня',
    liveAccounts: 'Реальные счета',
    demoAccounts: 'Демо счета',
    activeClients: 'Активные клиенты',
    activeTraders: 'Активные трейдеры',
    newClients: 'Новые клиенты',
    volumeChart: 'Объём торгов (7 дней)',
    pnlTrend: 'Динамика П&У (30 дней)',
    recentActivity: 'Последняя активность',
    quickActions: 'Быстрые действия',
    financialOverview: 'Финансовый обзор',
    financialOverview30Days: 'Финансовый обзор (30 дней)',
    riskAlerts: 'Риск-предупреждения',
    riskDistribution: 'Распределение рисков',
    currentPlan: 'Текущий план',
    planUsage: 'Использование плана',
    allowedMarkets: 'Доступные рынки',
    accountOverview: 'Обзор счетов',
    activeUsers: 'Активные пользователи',
    activeThisMonth: 'Активны в этом месяце',
    plan: 'план',
    feedLatency: 'Задержка котировок',
    expires: 'Истекает',
    cashFlowComparison: 'Сравнение денежных потоков',
    totalTransactions: 'всего транзакций',
    totalDeposits: 'всего пополнений',
    totalWithdrawals: 'всего выводов',
  },

  // Instruments
  instruments: {
    title: 'Управление инструментами',
    library: 'Библиотека инструментов',
    enabled: 'Активные инструменты',
    feed: 'Инструменты котировок',
    symbol: 'Символ',
    category: 'Категория',
    priceScale: 'Шкала цены',
    leverage: 'Кредитное плечо',
    spread: 'Спред',
    commission: 'Комиссия',
    enable: 'Включить',
    disable: 'Отключить',
    bulkEnable: 'Включить массово',
    settings: 'Настройки',
    tradeMode: 'Режим торговли',
    executionType: 'Тип исполнения',
    forex: 'Форекс',
    crypto: 'Крипто',
    stocks: 'Акции',
    indices: 'Индексы',
    commodities: 'Товары',
    general: 'Общие',
    leverageLots: 'Плечо и лоты',
    spreads: 'Спреды',
    commissions: 'Комиссии',
    riskManagement: 'Управление рисками',
    advanced: 'Расширенные',
    maxLeverage: 'Максимальное плечо',
    minLotSize: 'Минимальный лот',
    maxLotSize: 'Максимальный лот',
    lotStep: 'Шаг лота',
    spreadType: 'Тип спреда',
    spreadMarkup: 'Надбавка к спреду',
    fixedSpread: 'Фиксированный спред',
    commissionPerLot: 'Комиссия за лот',
    commissionType: 'Тип комиссии',
    stopLevel: 'Уровень стоп',
    freezeLevel: 'Уровень заморозки',
    maxPositions: 'Макс. позиций',
    enableSuccess: 'Инструмент успешно включён',
    disableSuccess: 'Инструмент успешно отключён',
    updateSuccess: 'Настройки успешно обновлены',
    bulkEnableSuccess: 'Инструменты успешно включены',
  },

  // Clients
  clients: {
    title: 'Клиенты',
    clientsList: 'Список клиентов',
    clientDetails: 'Данные клиента',
    name: 'Имя',
    email: 'Email',
    phone: 'Телефон',
    country: 'Страна',
    kycStatus: 'Статус KYC',
    accountCount: 'Счета',
    totalBalance: 'Общий баланс',
    lastLogin: 'Последний вход',
    createdAt: 'Дата создания',
    verified: 'Верифицирован',
    pending: 'Ожидание',
    rejected: 'Отклонён',
    searchPlaceholder: 'Поиск клиентов...',
    nameOrEmail: 'Имя или email…',
    editClient: 'Редактировать клиента',
    configureOverride: 'Настроить переопределение пользователя',
    noClientsFound: 'Клиенты не найдены',
  },

  // Accounts
  accounts: {
    title: 'Счета',
    accountsList: 'Список счетов',
    accountDetails: 'Данные счёта',
    accountNumber: 'Номер счёта',
    accountType: 'Тип счёта',
    accountGroup: 'Группа счёта',
    accountSettings: 'Настройки счёта',
    accountState: 'Состояние счёта',
    accountActive: 'Счёт активен',
    balance: 'Баланс',
    equity: 'Средства',
    margin: 'Маржа',
    freeMargin: 'Свободная маржа',
    marginLevel: 'Уровень маржи',
    leverage: 'Кредитное плечо',
    credit: 'Кредит',
    debit: 'Дебет',
    adjustBalance: 'Скорректировать баланс',
    changeLeverage: 'Изменить плечо',
    live: 'Реальный',
    demo: 'Демо',
    searchPlaceholder: 'Поиск по номеру счёта или email...',
    accountNumberOrEmail: 'Номер счёта или email…',
    balanceChange: 'Изменение баланса',
    reasonForAdjustment: 'Причина корректировки...',
    accountUpdatedSuccess: 'Счёт успешно обновлён',
    noAccountsFound: 'Счета не найдены',
  },

  // Trading
  trading: {
    title: 'Торговля',
    positions: 'Позиции',
    orders: 'Ордера',
    history: 'История',
    symbol: 'Символ',
    side: 'Направление',
    volume: 'Объём',
    openPrice: 'Цена открытия',
    currentPrice: 'Текущая цена',
    pnl: 'П&У',
    buy: 'Купить',
    sell: 'Продать',
    open: 'Открытые',
    pending: 'Ожидающие',
    closed: 'Закрытые',
    closedAt: 'Закрыто',
    openedAt: 'Открыто',
    price: 'Цена',
    totalTrades: 'Всего сделок',
    winningTrades: 'Прибыльные',
    losingTrades: 'Убыточные',
    totalPnL: 'Общий П&У',
    account: 'Счёт',
    status: 'Статус',
    swap: 'Своп',
    commission: 'Комиссия',
    ticket: 'Тикет',
    noPositions: 'Открытых позиций не найдено',
    noOrders: 'Ожидающих ордеров не найдено',
    noHistory: 'История торгов отсутствует',
    bid: 'Bid',
    ask: 'Ask',
    tradingManagement: 'Управление торговлей',
    liveMonitoring: 'Мониторинг в реальном времени',
    disconnected: 'Отключён',
    activeTraders: 'Активные трейдеры',
    openPositions: 'Открытые позиции',
    pendingOrders: 'Ожидающие ордера',
    floatPnL: 'Плавающий П&У',
    accountState: 'Состояние счёта',
    marginCall: 'МАРЖИН-КОЛЛ',
    stopOutRisk: 'РИСК СТОП-АУТ',
    live: 'В ПРЯМОМ ЭФИРЕ',
    offline: 'ОФЛАЙН',
    snapshot: 'СНИМОК',
    marginLvl: 'Уровень маржи',
    openTrades: 'Открытые сделки',
    freeMargin: 'Свободная маржа',
    marginUsed: 'Использованная маржа',
    balance: 'Баланс',
    equity: 'Средства',
    credit: 'Кредит',
    slTp: 'СЛ / ТП',
    fees: 'Комиссии',
    netPnL: 'Чистый П&У',
    grossPnL: 'Валовый П&У',
    reason: 'Причина',
    openedClosed: 'Открыто / Закрыто',
    closePrice: 'Цена закрытия',
    reserved: 'Зарезервировано',
    reservedMargin: 'Зарезервированная маржа',
    created: 'Создано',
    triggerPrice: 'Цена срабатывания',
    duration: 'Длительность',
    closedTrades: 'Закрытые сделки',
    activeTrades: 'Активные',
    stopLoss: 'Стоп-лосс',
    takeProfit: 'Тейк-профит',
    closePosition: 'Закрыть позицию',
    cancelOrder: 'Отменить ордер',
    modifyPosition: 'Изменить позицию',
    thisActionCannotBeUndone: 'Это действие нельзя отменить',
    enterStopLoss: 'Введите уровень стоп-лосс',
    enterTakeProfit: 'Введите уровень тейк-профит',
    filterTrading: 'Фильтр торговли',
    traderSymbolAccount: 'Трейдер, символ, счёт…',
    noFound: '{tab} не найдено',
    showingOf: 'Показано {from}–{to} из {total} трейдеров',
    traderCount: '{count} трейдер(ов) · {total} {tab}',
    positionClosedSuccess: 'Позиция успешно закрыта',
    orderCancelledSuccess: 'Ордер успешно отменён',
    positionModifiedSuccess: 'Позиция успешно изменена',
    failedToClosePosition: 'Не удалось закрыть позицию',
    failedToCancelOrder: 'Не удалось отменить ордер',
    failedToModifyPosition: 'Не удалось изменить позицию',
    invalidPosition: 'Недействительная позиция: отсутствует ID',
  },

  // Reports
  reports: {
    title: 'Отчёты',
    exposure: 'Отчёт об экспозиции',
    profitability: 'Прибыльность клиентов',
    daily: 'Ежедневный отчёт',
    dateRange: 'Диапазон дат',
    totalExposure: 'Общая экспозиция',
    netVolume: 'Чистый объём',
    topWinners: 'Лучшие по прибыли',
    topLosers: 'Лучшие по убыткам',
    buyVolume: 'Объём покупок',
    sellVolume: 'Объём продаж',
    positionCount: 'Количество позиций',
    winRate: 'Процент прибыльных',
    rank: 'Место',
    client: 'Клиент',
    noData: 'Нет данных',
    totalVolume: 'Общий объём',
    commission: 'Комиссия',
    activeAccounts: 'Активные счета',
    export: 'Экспорт',
    download: 'Скачать',
    positions: 'Позиции',
    trades: 'Сделки',
    winning: 'Прибыльные',
    losing: 'Убыточные',
  },

  // Settings
  settings: {
    title: 'Настройки',
    brokerInfo: 'Информация о брокере',
    brokerSettings: 'Настройки брокера',
    brokerName: 'Название брокера',
    brokerNameRequired: 'Название брокера *',
    brokerLogo: 'Логотип брокера',
    brokerStatus: 'Статус брокера',
    domain: 'Домен',
    primaryColor: 'Основной цвет',
    secondaryColor: 'Дополнительный цвет',
    logo: 'Логотип',
    supportEmail: 'Email поддержки',
    supportPhone: 'Телефон поддержки',
    generalInfo: 'Общая информация',
    branding: 'Брендинг',
    accountGroups: 'Группы счетов',
    addNewGroup: 'Добавить группу',
    createFirstGroup: 'Создать первую группу',
    noGroupsFound: 'Группы счетов не найдены',
    default: 'По умолчанию',
    maxLeverage: 'Максимальное плечо',
    marginCall: 'Маржин-колл',
    stopOut: 'Стоп-аут',
    commission: 'Комиссия',
    maxLotSize: 'Максимальный лот',
    execution: 'Исполнение',
    hedgingAllowed: 'Разрешён хеджинг',
    scalpingAllowed: 'Разрешён скальпинг',
    eaTrading: 'Торговля EA',
    nbpEnabled: 'NBP включён',
    saving: 'Сохранение...',
    groupName: 'Название группы',
    description: 'Описание',
    editGroup: 'Редактировать группу',
    deleteGroup: 'Удалить группу',
    cannotDeleteDefault: 'Нельзя удалить группу по умолчанию',
    confirmDelete: 'Вы уверены, что хотите удалить "{name}"? Это действие нельзя отменить.',
    groupCreatedSuccess: 'Группа успешно создана',
    groupUpdatedSuccess: 'Группа успешно обновлена',
    groupDeletedSuccess: 'Группа успешно удалена',
    failedToSave: 'Не удалось сохранить группу',
    failedToDelete: 'Не удалось удалить группу',
    failedToLoad: 'Не удалось загрузить группы счетов',
    configureYourBroker: 'Настройте информацию и параметры вашего брокера',
    loadingSettings: 'Загрузка настроек...',
    legalName: 'Юридическое название',
    licenseNumber: 'Номер лицензии',
    environment: 'Среда',
    contactInformation: 'Контактная информация',
    readOnly: 'Только чтение',
    readOnlyContactSupport: 'Только чтение — обратитесь в поддержку для изменения',
    supportedLanguages: 'Поддерживаемые языки',
    selectLanguagesDescription: 'Выберите языки, доступные на клиентском портале. Необходимо выбрать хотя бы один.',
    systemLimits: 'Системные ограничения',
    maxAccounts: 'Макс. счетов',
    maxConcurrentTrades: 'Макс. одновременных сделок',
    maintenanceMode: 'Режим обслуживания',
    enableMaintenanceMode: 'Включить режим обслуживания',
    maintenanceModeDescription: 'При включении клиенты увидят сообщение об обслуживании вместо платформы',
    maintenanceMessage: 'Сообщение об обслуживании',
    maintenanceMessagePlaceholder: 'Выполняется плановое техническое обслуживание. Пожалуйста, вернитесь позже.',
    saveChanges: 'Сохранить изменения',
    howToConnectDomain: 'Как подключить домен',
    unlockToEdit: 'Разблокировать для редактирования домена',
    lockDomain: 'Заблокировать домен',
    changingDomainWarning: 'Изменение домена может нарушить доступ клиентов. Вы уверены, что хотите разблокировать?',
    changingDomainWarningLong: 'Изменение домена может временно нарушить доступ клиентов и настройки DNS. Вы уверены?',
    domainBreakWarning: '⚠️ Изменение домена может временно нарушить доступ существующих клиентов',
    domainBreakWarningLong: '⚠️ Изменение домена может временно нарушить доступ клиентов и маршрутизацию DNS',
  },

  // Account Groups
  accountGroups: {
    title: 'Группы счетов',
    activeGroups: 'активных',
    defaultGroups: 'по умолчанию',
    addNewGroup: 'Добавить группу',
    createFirstGroup: 'Создать первую группу',
    noGroupsFound: 'Группы счетов не найдены',
    groupDetails: 'Данные группы',
    pricingOverrides: 'Переопределения цен',
    riskSettings: 'Настройки риска',
    tradingSettings: 'Торговые настройки',
  },

  // Group Pricing
  groupPricing: {
    title: 'Переопределения цен группы',
    infoBanner: 'Переопределения цен группы счетов',
    infoDescription: 'Настройте индивидуальное ценообразование для групп счетов. Оставьте поля пустыми (NULL) для использования настроек брокера.',
    editPricingOverrides: 'Редактировать переопределения цен',
    spreadMarkup: 'Надбавка к спреду',
    spreadMarkupPips: 'Надбавка к спреду (пипсы)',
    commission: 'Комиссия',
    commissionPerLot: 'Комиссия за лот (USD)',
    maxLeverageOverride: 'Переопределение макс. плеча',
    brokerDefault: 'По умолчанию брокера',
    useBrokerDefault: 'Использовать настройки брокера',
    clearUseBrokerDefault: 'Очистить (использовать настройки брокера)',
    saveOverrides: 'Сохранить переопределения',
    overridesUpdatedSuccess: 'Переопределения цен группы успешно обновлены',
    failedToUpdate: 'Не удалось обновить переопределения',
    leaveEmptyInfo: 'Оставьте поля пустыми для использования настроек брокера. Задавайте только значения для этой группы.',
    pips: 'пипсы',
    perLot: '/лот',
  },

  // KYC
  kyc: {
    title: 'Панель KYC',
    allKyc: 'Все KYC',
    allStatus: 'Все статусы',
    allKycStatus: 'Все статусы KYC',
    pending: 'Ожидание',
    approved: 'Одобрено',
    rejected: 'Отклонено',
    verified: 'Верифицирован',
    actionNeeded: 'Требуется действие',
    awaitingAction: 'Ожидание действия',
    allCaughtUp: 'Всё обработано!',
    noApplications: 'На данный момент нет ожидающих заявок KYC.',
    searchPlaceholder: 'Поиск по имени, email или ID...',
    nameEmailOrId: 'ID, имя или email…',
    confirmApproval: 'Подтвердить одобрение KYC',
    confirmRejection: 'Подтвердить отклонение — введите причину (обязательно).',
    rejectionReason: 'Укажите причину отклонения заявки (обязательно)',
    approveSuccess: 'KYC успешно одобрен',
    rejectSuccess: 'KYC успешно отклонён',
    failedToApprove: 'Не удалось одобрить KYC',
    failedToReject: 'Не удалось отклонить KYC',
    basicVerified: 'Базовая верификация',
    fullVerified: 'Полная верификация',
    allApplications: 'Все заявки',
    kycVerification: 'Верификация KYC',
    reviewManageDesc: 'Проверка и управление заявками на верификацию клиентов',
    pluginSettings: 'Настройки плагина',
    reviewKycApplication: 'Проверить заявку KYC',
    verificationLevel: 'Уровень верификации',
    personalInformation: 'Личная информация',
    fullName: 'Полное имя',
    dateOfBirth: 'Дата рождения',
    nationality: 'Гражданство',
    addressLabel: 'Адрес',
    sourceOfFunds: 'Источник средств',
    noPersonalData: 'Личные данные ещё не предоставлены',
    uploadedDocuments: 'Загруженные документы',
    noDocumentsUploaded: 'Документы ещё не загружены',
    yourDecision: 'Ваше решение',
    approve: 'Одобрить',
    reject: 'Отклонить',
    rejectionReasonLabel: 'Причина отклонения',
    submitting: 'Отправка…',
    submitReview: 'Отправить решение',
    previewNotAvailable: 'Предпросмотр недоступен',
    downloadFile: 'Скачать файл',
    uploaded: 'Загружено',
    pendingReview: 'На проверке',
    allLevels: 'Все уровни',
    allStatuses: 'Все статусы',
    allActions: 'Все действия',
    userCol: 'Пользователь',
    currentLevel: 'Текущий уровень',
    docsCol: 'Документы',
    lastUpdated: 'Последнее обновление',
    levelCol: 'Уровень',
    actionCol: 'Действие',
    performedBy: 'Выполнено',
    detailsCol: 'Детали',
    dateTime: 'Дата и время',
    submittedCol: 'Подано',
    noApplicationsFound: 'Заявки не найдены',
    noAuditRecords: 'Записи аудита не найдены',
    noMatchingApplications: 'Соответствующие заявки не найдены',
    noPendingApplications: 'Ожидающих заявок нет',
    systemAuto: 'Система (авто)',
    admin: 'Администратор',
    traderLabel: 'Трейдер',
    upgradedTo: 'Повышен до',
    pendingApplications: 'ожидающая заявка',
    pendingApplicationsPlural: 'ожидающих заявок',
    users: 'пользователь',
    usersPlural: 'пользователей',
    records: 'запись',
    recordsPlural: 'записей',
    applications: 'заявка',
    applicationsPlural: 'заявок',
    totalUsers: 'Всего пользователей',
    basicVerifiedStat: 'Базовая верификация',
    moderateVerified: 'Средняя верификация',
    fullyVerified: 'Полная верификация',
    pendingSuffix: '+{count} ожидающих',
    levelBasic: 'Базовый',
    levelModerate: 'Средний',
    levelVerified: 'Верифицирован',
    notStarted: 'Не начат',
    none: 'Нет',
    unknown: 'Неизвестно',
    review: 'Проверить',
    auditLog: 'Журнал аудита',
    requiredDocuments: 'Необходимые документы',
    requiredDocsDesc: 'Выберите документы, которые трейдеры должны загрузить для каждого уровня KYC. Для каждого уровня требуется хотя бы один документ.',
    kycDocuments: 'Документы KYC {level}',
    selected: 'Выбрано: {count}',
    approvalMode: 'Режим одобрения',
    manualReview: 'Ручная проверка',
    autoApprove: 'Автоматическое одобрение',
    autoApproveLevels: 'Уровни автоодобрения',
    basicKyc: 'Базовый KYC',
    moderateKyc: 'Средний KYC',
    verifiedKyc: 'Верифицированный KYC',
    enforceOnDeposit: 'Требовать KYC при пополнении',
    enforceOnWithdrawal: 'Требовать KYC при выводе',
    basic: 'Базовый',
    moderate: 'Средний',
    verified: 'Верифицирован',
    howItWorks: 'Как это работает:',
    howItWorksBullet1: 'Суммы ниже базового порога: KYC не требуется',
    howItWorksBullet2: 'Суммы выше базового: требуется базовый KYC',
    howItWorksBullet3: 'Суммы выше среднего: требуется средний KYC',
    howItWorksBullet4: 'Суммы выше верифицированного: требуется полная верификация',
    saveConfiguration: 'Сохранить настройки',
    savingConfiguration: 'Сохранение...',
    openKycDashboard: 'Открыть панель KYC',
    enableToViewStats: 'Включите плагин для просмотра статистики',
    statNone: 'Нет',
    docGovIdFrontLabel: 'Удостоверение личности (лицевая сторона)',
    docGovIdFrontDesc: 'Паспорт, водительское удостоверение или нац. ID — лицевая сторона',
    docGovIdBackLabel: 'Удостоверение личности (оборотная сторона)',
    docGovIdBackDesc: 'Оборотная сторона удостоверения',
    docSelfieLabel: 'Селфи с документом',
    docSelfieDesc: 'Фото с документом рядом с лицом',
    docProofAddressLabel: 'Подтверждение адреса',
    docProofAddressDesc: 'Квитанция за коммунальные услуги или банковская выписка (не старше 3 месяцев)',
    docBankStatementLabel: 'Банковская выписка',
    docBankStatementDesc: 'Актуальная выписка с именем и счётом',
    docSourceFundsLabel: 'Источник средств',
    docSourceFundsDesc: 'Документ, подтверждающий источник торговых средств',
    docEmploymentLabel: 'Письмо о трудоустройстве',
    docEmploymentDesc: 'Подтверждение от работодателя',
    docTaxIdLabel: 'ИНН / налоговый документ',
    docTaxIdDesc: 'Свидетельство о постановке на налоговый учёт',
    docOtherLabel: 'Прочие документы',
    docOtherDesc: 'Дополнительные подтверждающие документы',
    auditActions: {
      submitted: 'Подано',
      approved: 'Одобрено',
      rejected: 'Отклонено',
      document_uploaded: 'Документ загружен',
      document_approved: 'Документ одобрен',
      document_rejected: 'Документ отклонён',
      level_upgraded: 'Уровень повышен',
      resubmission: 'Повторная подача',
    },
  },

  // Deposits
  deposits: {
    title: 'Пополнения',
    allDeposits: 'Все пополнения',
    allStatuses: 'Все статусы',
    pending: 'Ожидание',
    approved: 'Одобрено',
    rejected: 'Отклонено',
    completed: 'Завершено',
    searchPlaceholder: 'Поиск пополнений…',
    searchByIdNameEmail: 'Поиск по ID, имени или email трейдера…',
    idNameOrEmail: 'ID, имя или email…',
    depositProof: 'Подтверждение пополнения',
    depositProofPdf: 'PDF подтверждения пополнения',
    amount: 'Сумма',
    method: 'Метод',
    status: 'Статус',
    trader: 'Трейдер',
    date: 'Дата',
    actions: 'Действия',
    approve: 'Одобрить',
    reject: 'Отклонить',
    confirmApproval: 'Подтвердить одобрение — баланс трейдера будет пополнен.',
    confirmRejection: 'Подтвердить отклонение — введите причину (необязательно).',
    rejectionReason: 'Причина отклонения (необязательно)…',
    approveSuccess: 'Пополнение успешно одобрено',
    rejectSuccess: 'Пополнение успешно отклонено',
    failedToApprove: 'Не удалось одобрить пополнение',
    failedToReject: 'Не удалось отклонить пополнение',
    noDepositsFound: 'Пополнения не найдены',
    proofThumbnail: 'Миниатюра подтверждения',
    zoomIn: 'Приблизить',
    zoomOut: 'Отдалить',
    openInNewTab: 'Открыть в новой вкладке',
    bank: 'Банк',
    crypto: 'Крипто',
    card: 'Карта',
    bankPerCountry: 'Банк (по стране)',
    bankPerUser: 'Банк (по пользователю)',
    bankTransfer: 'Банковский перевод',
    bankTransferPerCountry: 'Банковский перевод (по стране)',
    bankTransferPerUser: 'Банковский перевод (по пользователю)',
    averageDeposit: 'Среднее пополнение',
  },

  // Withdrawals
  withdrawals: {
    title: 'Вывод средств',
    allWithdrawals: 'Все выводы',
    allStatuses: 'Все статусы',
    pending: 'Ожидание',
    approved: 'Одобрено',
    rejected: 'Отклонено',
    completed: 'Завершено',
    searchPlaceholder: 'Поиск выводов…',
    searchByIdNameEmail: 'Поиск по ID, имени или email трейдера…',
    idNameOrEmail: 'ID, имя или email…',
    amount: 'Сумма',
    method: 'Метод',
    status: 'Статус',
    trader: 'Трейдер',
    date: 'Дата',
    actions: 'Действия',
    approve: 'Одобрить',
    reject: 'Отклонить',
    confirmApproval: 'Подтвердить одобрение — средства будут переведены по реквизитам трейдера.',
    confirmWithdrawalApproval: 'Подтвердить одобрение вывода — средства будут переведены по реквизитам трейдера.',
    confirmRejection: 'Подтвердить отклонение — введите причину (необязательно).',
    rejectionReason: 'Причина отклонения (необязательно)…',
    approveSuccess: 'Вывод успешно одобрен',
    rejectSuccess: 'Вывод успешно отклонён',
    failedToApprove: 'Не удалось одобрить вывод',
    failedToReject: 'Не удалось отклонить вывод',
    noWithdrawalsFound: 'Выводы не найдены',
    averageWithdrawal: 'Средний вывод',
  },

  // Audit Log
  auditLog: {
    title: 'Журнал аудита',
    allActions: 'Все действия',
    allEvents: 'Все события',
    allLevels: 'Все уровни',
    searchPlaceholder: 'Поиск в журнале аудита…',
    emailActionOrId: 'Email, действие или ID…',
    event: 'Событие',
    user: 'Пользователь',
    action: 'Действие',
    timestamp: 'Временная метка',
    details: 'Детали',
    level: 'Уровень',
    info: 'Инфо',
    warning: 'Предупреждение',
    error: 'Ошибка',
    critical: 'Критическое',
    noLogsFound: 'Записи аудита не найдены',
    administrativeAction: 'Было зарегистрировано административное действие.',
    filterAuditLog: 'Фильтр журнала аудита',
    reset: 'Сбросить',
    eventType: 'Тип события',
    apply: 'Применить',
    totalEvents: 'Всего событий',
    depositEvents: 'События пополнений',
    withdrawalEvents: 'События выводов',
    noEventsMatch: 'Нет событий, соответствующих фильтру',
    noEntriesMatch: 'Нет записей аудита, соответствующих текущему фильтру.',
    showAll: 'Показать все',
    events: 'событие',
    eventsPlural: 'событий',
    totalEventsRecorded: 'Всего зарегистрированных событий',
    performedBy: 'Выполнено',
    amount: 'Сумма',
    paymentMethod: 'Способ оплаты',
    balanceChange: 'Изменение баланса',
    statusChange: 'Изменение статуса',
    rejectionReason: 'Причина отклонения',
    actionWithdrawalRequested: 'Запрос на вывод',
    actionDepositSubmitted: 'Пополнение отправлено',
    actionProofUploaded: 'Подтверждение загружено',
    actionDepositApproved: 'Пополнение одобрено',
    actionDepositRejected: 'Пополнение отклонено',
    actionWithdrawalApproved: 'Вывод одобрен',
    actionWithdrawalRejected: 'Вывод отклонён',
    actionFundsLocked: 'Средства заблокированы',
    actionFundsReturned: 'Средства возвращены',
    fundsLockedSummary: 'Средства заблокированы на счёте трейдера в ожидании проверки вывода.',
    fundsReturnedSummary: 'Заблокированные средства возвращены трейдеру после отклонения.',
    depositsTab: 'Пополнения',
    withdrawalsTab: 'Выводы',
  },

  // Plugins
  plugins: {
    title: 'Плагины',
    backToPlugins: 'К плагинам',
    searchPlaceholder: 'Поиск плагинов…',
    countrySelectNoMatch: 'Нет совпадений',
    configurePlugin: 'Настроить плагин',
    pressEscToClose: 'Нажмите {key} для закрытия',
    loadingUsers: 'Загрузка…',
    available: 'Доступно',
    active: 'Активный',
    activate: 'Активировать',
    deactivate: 'Деактивировать',
    configure: 'Настроить',
    documentation: 'Документация',
    settings: 'Настройки',
    noPluginsFound: 'Плагины не найдены',
    pluginDetails: 'Данные плагина',
    version: 'Версия',
    author: 'Автор',
    description: 'Описание',
    filterInactive: 'Неактивные',
    paymentGateways: 'Платёжные шлюзы',
    stripeTitle: 'Stripe',
    stripeDescription: 'Приём платежей через Stripe',
    paypalTitle: 'PayPal',
    paypalDescription: 'Приём платежей через PayPal',
    communicationTools: 'Инструменты коммуникации',
    twilioTitle: 'Twilio SMS',
    twilioDescription: 'Отправка SMS-уведомлений',
    mailgunTitle: 'Mailgun',
    mailgunDescription: 'Сервис доставки email',
    bankFieldAccountHolder: 'Владелец счёта',
    bankFieldBankName: 'Название банка',
    bankFieldAccountNumber: 'Номер счёта',
    bankFieldRoutingNumber: 'Маршрутный номер (необязательно)',
    bankFieldSetAsDefault: 'Установить по умолчанию (глобальный резерв)',
    copyTradingTitle: 'Копирование сделок',
    copyTradingDescription: 'Включить функции копирования сделок',
    tradingTools: 'Торговые инструменты',
    mam: 'MAM/PAMM',
    apiKey: 'API-ключ',
    apiSecret: 'API-секрет',
    accountSid: 'SID аккаунта',
    authToken: 'Токен авторизации',
    authDomain: 'Домен авторизации',
    appId: 'ID приложения',
    loadingPlugins: 'Загрузка плагинов…',
    noPluginsMatch: 'Нет плагинов, соответствующих критериям',
    tryDifferentSearch: 'Попробуйте другой поиск или фильтр',
    tryAdjustingSearch: 'Попробуйте изменить поиск или фильтр',
    activeCount: '{count} активных · {owned} приобретено · {available} в магазине',
    ofPurchasedActive: '{count} из приобретённых активны',
    expired: 'Истёк',
    expires: 'Истекает',
    free: 'Бесплатно',
    buyPlugin: 'Купить — ${price}{cycle}',
    openInFullPage: 'Открыть на полной странице',
    noConfigPanel: 'Для этого плагина нет панели настроек.',
    currentStatus: 'Текущий статус',
    failedToUpdateKyc: 'Не удалось обновить настройки KYC',
    filterAll: 'Все',
    filterActive: 'Активные',
    filterOwned: 'Приобретённые',
    filterStore: 'Магазин',
    pluginNotFound: 'Плагин не найден',
    loadingPlugin: 'Загрузка плагина...',
    failedToLoadPlugin: 'Не удалось загрузить плагин',
    noConfigAvailable: 'Для этого плагина нет панели настроек.',
    activeStatus: 'Активный',
    editLabel: 'Редактировать',
    newLabel: 'Новый',
    addLabel: 'Добавить',
    saveLabel: 'Сохранить',
    cancelLabel: 'Отмена',
    globalBankAccount: 'Глобальный банковский счёт',
    addBankAccount: 'Добавить банковский счёт',
    defaultLabel: '(по умолчанию)',
    cryptoWallet: 'Крипто-кошелёк',
    addCryptoWallet: 'Добавить крипто-кошелёк',
    coinPlaceholder: 'Монета (напр. BTC)',
    networkPlaceholder: 'Сеть (напр. mainnet)',
    walletAddressPlaceholder: 'Адрес кошелька',
    labelOptionalPlaceholder: 'Метка (необязательно)',
    paymentLink: 'Платёжная ссылка',
    addPaymentLink: 'Добавить платёжную ссылку',
    linkNamePlaceholder: 'Название (напр. Stripe Checkout)',
    perUserBankAccount: 'Банковский счёт по пользователю',
    addUserBankMapping: 'Добавить привязку пользователь → банк',
    editExistingAccount: 'Редактировать существующий счёт',
    assignedUsers: 'Назначенные пользователи',
    pickTraders: 'Выбрать трейдера(ов)',
    searchAddTrader: 'Найти и добавить трейдера…',
    perCountryBankAccount: 'Банковский счёт по стране',
    addCountryBankMapping: 'Добавить привязку страна → банк',
    mappedCountries: 'Привязанные страны',
    pickCountries: 'Выбрать страну(ы)',
    searchAddCountries: 'Найти и добавить страны…',
    badgeActive: 'Активный',
    badgeInactive: 'Неактивный',
    badgeExpired: 'Истёк',
    purchasePlugin: 'Купить плагин',
    paymentMethod: 'Способ оплаты',
    generatePaymentAddress: 'Сгенерировать адрес платежа',
    sendExactly: 'Отправить точно',
    toAddressBelow: 'на адрес ниже',
    paymentAddress: 'Адрес платежа',
    waitingForPayment: 'Ожидание платежа...',
    paymentDetected: 'Платёж обнаружен! Подтверждение...',
    confirmationsReceived: 'Получено {count} подтверждение',
    confirmationsReceivedPlural: 'Получено {count} подтверждений',
    expiresIn: 'Истекает через:',
    paymentId: 'ID платежа:',
    paymentConfirmed: 'Платёж подтверждён!',
    pluginActivated: '{name} активирован.',
    networkError: 'Ошибка сети. Пожалуйста, попробуйте снова.',
    failedToCreatePayment: 'Не удалось создать платёж',
    paymentExpired: 'Окно платежа истекло. Пожалуйста, создайте новый платёж.',
  },

  // API Docs
  apiDocs: {
    title: 'Документация API',
    authentication: 'Аутентификация',
    baseUrl: 'Базовый URL:',
    allRequestsRequire: 'Все запросы требуют два заголовка:',
    apiKeyManagement: 'Управление API-ключами с контролем прав доступа',
    billing: 'Выставление счетов',
    apiAccess: 'Доступ к API',
    apiAccessAddon: 'Дополнение API Access активно',
    buyAddon: 'Купить дополнение — $199/мес',
    getAccounts: 'GET /accounts',
    getAccountDetails: 'GET /accounts/:id',
    updateAccount: 'PATCH /accounts/:id',
    getDeposits: 'GET /deposits',
    approveDeposit: 'POST /deposits/:id/approve',
    rejectDeposit: 'POST /deposits/:id/reject',
    getWithdrawals: 'GET /withdrawals',
    approveWithdrawal: 'POST /withdrawals/:id/approve',
    rejectWithdrawal: 'POST /withdrawals/:id/reject',
    approvalsDescription: 'Одобрение пополнений и выводов программным способом',
    approveDepositDesc: 'Одобрить пополнение (статус должен быть proof_uploaded). Зачисляет баланс счёта, регистрирует транзакцию, уведомляет движок. Тело: notes?. Возвращает balance_before и balance_after.',
    approveWithdrawalDesc: 'Одобрить ожидающий вывод. Баланс уже заблокирован при запросе. Тело: notes?',
    restApi: 'REST API',
    baseUrlLabel: 'Базовый URL:',
    yourApiKeys: 'Ваши API-ключи',
    noApiKeysYet: 'API-ключей пока нет',
    generateNewKey: 'Создать новый ключ',
    revokeKey: 'Отозвать',
    rateLimit: 'Лимит запросов',
    maxKeys: 'Макс. ключей',
    reqPerMin: '{limit} зап/мин',
    exampleRequest: 'Пример запроса',
    queryParameters: 'Параметры запроса',
    endpoints: 'эндпоинт',
    endpointsPlural: 'эндпоинтов',
    includedInPlan: 'Включено в ваш план Enterprise',
    addonActive: 'Дополнение API Access активно',
    restApiAccess: 'Доступ к REST API',
    restApiDesc: 'Доступ к REST API доступен в плане Enterprise или как отдельное дополнение для любого плана. Подключите свои системы напрямую к брокерской платформе.',
    featureReadClients: 'Чтение клиентов, счетов и истории сделок',
    featureApprovePayments: 'Одобрение пополнений и выводов программным способом',
    featureApiKeyManagement: 'Управление API-ключами с контролем прав доступа',
    featureRateLimit: 'До 60 запросов в минуту на ключ',
    featureInteractiveDocs: 'Интерактивная документация в панели управления',
    upgradeToEnterprise: 'Обновить до Enterprise',
    buyAddonPrice: 'Купить дополнение — $199/мес',
    generateApiKey: 'Создать API-ключ',
    keyName: 'Название ключа',
    keyNamePlaceholder: 'напр. Производственный ключ',
    scopes: 'Права доступа',
    generating: 'Создание...',
    generateKey: 'Создать ключ',
    keyGenerated: 'Ключ создан',
    copySecretWarning: '⚠️ Скопируйте секрет сейчас — он больше не будет показан.',
    apiKeyLabel: 'API-ключ',
    apiSecretLabel: 'API-секрет',
    done: 'Готово',
    enterKeyName: 'Введите название ключа',
    failedToCreateKey: 'Не удалось создать ключ',
    keyRevoked: 'Ключ отозван',
    confirmRevoke: 'Отозвать этот API-ключ? Это действие нельзя отменить.',
  },

  // Notifications
  notifications: {
    title: 'Настройки уведомлений',
    emailNotifications: 'Email-уведомления',
    smsNotifications: 'SMS-уведомления',
    pushNotifications: 'Push-уведомления',
    deposits: 'Пополнения',
    withdrawals: 'Выводы',
    newClients: 'Новые клиенты',
    kycApplications: 'Заявки KYC',
    systemAlerts: 'Системные предупреждения',
    enabled: 'Включено',
    disabled: 'Отключено',
    saveSettings: 'Сохранить настройки',
    settingsSaved: 'Настройки успешно сохранены',
    notificationChannels: 'Каналы уведомлений',
    configureChannels: 'Настройте способы отправки оповещений клиентам. Включайте только настроенные каналы.',
    saveAll: 'Сохранить всё',
    saving: 'Сохранение...',
    enableToConfigure: 'Включите для настройки {title}',
    emailSmtp: 'Email (SMTP)',
    emailSmtpSubtitle: 'Отправка писем через собственный SMTP-сервер',
    recommended: 'Рекомендуется',
    smtpHost: 'SMTP-хост',
    smtpPort: 'SMTP-порт',
    usernameEmail: 'Пользователь / Email',
    passwordAppPassword: 'Пароль / Пароль приложения',
    fromEmail: 'Email отправителя',
    fromName: 'Имя отправителя',
    useTls: 'Использовать TLS / STARTTLS',
    useTlsHint: 'Рекомендуется для порта 587. Отключите для порта 465 (SSL).',
    sendTestEmail: 'Отправить тестовое письмо',
    pushFcm: 'Push-уведомления (FCM)',
    pushFcmSubtitle: 'Firebase Cloud Messaging для Android, iOS и Web',
    pushSetupRequired: 'Требуется настройка',
    pushSetupDesc: 'Перейдите в Firebase Console → Настройки проекта → Служебные аккаунты → Создать новый ключ. Скачайте JSON-файл и загрузите ниже.',
    serviceAccountCredentials: 'Учётные данные служебного аккаунта',
    clientTokenStatus: 'Статус токена клиента',
    clientTokenDesc: 'Push-токены регистрируются автоматически при входе клиентов через мобильное/веб-приложение. Ручная настройка не требуется.',
    testPush: 'Тест Push',
    webAppConfig: 'Конфигурация веб-приложения',
    webAppConfigured: 'Настроено — {project}',
    webAppRequired: 'Требуется для push в браузере и на мобильных устройствах',
    webAppWhereToFind: 'Где найти',
    webAppWhereToFindDesc: 'Firebase Console → Настройки проекта → Ваши приложения → Веб-приложение → Настройка SDK',
    saveWebConfig: 'Сохранить веб-конфигурацию',
    vapidKey: 'VAPID-ключ',
    vapidKeyHint: '— Вкладка Cloud Messaging → Веб-сертификаты Push → Создать пару ключей',
    credentialsOnFile: 'Учётные данные на файле',
    credentialsStoredSecurely: 'Безопасно хранятся на сервере',
    replaceCredentials: 'Заменить',
    uploadServiceAccount: 'Загрузить JSON служебного аккаунта',
    uploadServiceAccountHint: 'Нажмите для выбора — файл будет проверен и безопасно сохранён',
    uploadingValidating: 'Загрузка и проверка...',
    uploadSuccess: 'Учётные данные Firebase успешно загружены',
    uploadFailed: 'Ошибка загрузки — убедитесь, что файл является действительным JSON служебного аккаунта Firebase',
    saveWebConfigSuccess: 'Веб-конфигурация Firebase сохранена',
    saveWebConfigFailed: 'Не удалось сохранить веб-конфигурацию',
    smsTwilio: 'SMS (Twilio)',
    smsTwilioSubtitle: 'Отправка SMS-оповещений через Twilio клиентам с номерами телефонов',
    smsSetupRequired: 'Требуется настройка',
    smsSetupDesc: 'Получите учётные данные на console.twilio.com → Аккаунт → API-ключи и токены. Вам также понадобится номер телефона Twilio.',
    accountSid: 'SID аккаунта',
    accountSidHint: 'Начинается с AC...',
    authToken: 'Токен авторизации',
    fromPhoneNumber: 'Номер телефона отправителя',
    fromPhoneHint: 'Формат E.164, напр. +74951234567',
    sendTestSms: 'Отправить тестовое SMS',
    statusConnected: 'Подключено',
    statusError: 'Ошибка',
    statusUntested: 'Не проверено',
    statusTesting: 'Проверка...',
    notificationRouting: 'Маршрутизация уведомлений',
    notificationRoutingDesc: 'Выберите каналы для каждого типа уведомлений',
    noChannelsEnabled: 'Нет активных каналов',
    noChannelsEnabledDesc: 'Включите хотя бы один канал для настройки маршрутизации уведомлений',
    notifMarginCall: 'Маржин-колл',
    notifMarginCallDesc: 'Когда уровень маржи счёта падает ниже порога',
    notifLiquidation: 'Ликвидация',
    notifLiquidationDesc: 'Когда позиции принудительно закрываются',
    notifDeposit: 'Пополнение',
    notifDepositDesc: 'Когда пополнение подтверждено',
    notifWithdrawal: 'Вывод',
    notifWithdrawalDesc: 'Когда вывод обработан',
    notifTradeOpened: 'Сделка открыта',
    notifTradeOpenedDesc: 'Когда открыта новая позиция',
    notifTradeClosed: 'Сделка закрыта',
    notifTradeClosedDesc: 'Когда позиция закрыта',
    failedToLoad: 'Не удалось загрузить настройки уведомлений',
    failedToSave: 'Не удалось сохранить',
    testSuccess: 'Тест {channel} успешен — проверьте входящие/устройство',
    testFailed: 'Тест {channel} не удался',
  },

  // Upgrade
  upgrade: {
    title: 'Обновить план',
    currentPlan: 'Текущий план',
    choosePlan: 'Выбрать план',
    basic: 'Базовый',
    professional: 'Профессиональный',
    enterprise: 'Корпоративный',
    perMonth: '/мес',
    perYear: '/год',
    monthly: 'Ежемесячно',
    annually: 'Ежегодно',
    features: 'Возможности',
    selectPlan: 'Выбрать план',
    currentPlanLabel: 'Текущий план',
    upgradeTo: 'Обновить до',
    contactSales: 'Связаться с отделом продаж',
    unlimitedClients: 'Неограниченно клиентов',
    unlimitedAccounts: 'Неограниченно счетов',
    advancedReporting: 'Расширенная отчётность',
    prioritySupport: 'Приоритетная поддержка',
    apiAccess: 'Доступ к API',
    customBranding: 'Индивидуальный брендинг',
    whiteLabel: 'White Label',
    dedicatedManager: 'Персональный менеджер',
    upgradeAvailable: 'Доступно обновление',
    plan: 'план',
    unlock: 'Разблокировать',
    apiAccessFeature: ', доступ к API',
    andMore: '& ещё',
    renew: 'Продлить',
  },

  // Theme
  theme: {
    light: 'Светлая тема',
    dark: 'Тёмная тема',
    toggle: 'Переключить тему',
  },

  // Language
  language: {
    english: 'English',
    arabic: 'العربية',
    turkish: 'Türkçe',
    select: 'Выбрать язык',
  },

  // Errors
  errors: {
    general: 'Что-то пошло не так',
    networkError: 'Ошибка сети. Проверьте подключение.',
    unauthorized: 'Нет авторизации. Пожалуйста, войдите снова.',
    forbidden: 'Доступ запрещён.',
    notFound: 'Ресурс не найден.',
    serverError: 'Ошибка сервера. Попробуйте позже.',
    actionFailed: 'Действие не выполнено',
  },

  // Success messages
  success: {
    saved: 'Сохранено успешно',
    updated: 'Обновлено успешно',
    deleted: 'Удалено успешно',
    created: 'Создано успешно',
    copied: 'Скопировано в буфер обмена',
  },

  // Time & Date
  time: {
    seconds: 'секунд',
    minutes: 'минут',
    hours: 'часов',
    days: 'дней',
    weeks: 'недель',
    months: 'месяцев',
    years: 'лет',
    ago: 'назад',
    justNow: 'только что',
    today: 'Сегодня',
    yesterday: 'Вчера',
    tomorrow: 'Завтра',
  },

  // Units
  units: {
    usd: 'USD',
    eur: 'EUR',
    gbp: 'GBP',
    lot: 'лот',
    lots: 'лотов',
    pips: 'пипсы',
    percent: '%',
  },

  cascade: {
    settingsArchitecture: 'Архитектура настроек',
    title: 'Каскадная система приоритетов',
    subtitle: 'Настройки применяются от наивысшего → к низшему приоритету. Оставьте поле',
    subtitleNull: 'пустым (NULL)',
    subtitleFallthrough: 'чтобы пропустить слой и перейти к следующему.',
    resolutionOrder: 'Порядок применения:',
    firstNonNull: 'Побеждает первое ненулевое значение',
    highestPriority: 'Наивысший приоритет — нажмите на любой слой для изучения',
    ifEmptyFallsThrough: '↓ если пусто, переходит дальше',
    priority: 'Приоритет',
    leaveFieldEmpty: 'Оставьте любое поле пустым (NULL)',
    skipLayer: 'чтобы пропустить этот слой и перейти к',
    finalFallback: 'Финальный резерв — ниже нет слоёв.',
    hardLimitsNote: 'Поля, отмеченные как',
    hardLimitsNote2: 'являются жёсткими ограничениями всей системы, ни один слой не может их обойти.',
    layers: {
      userOverride: 'Переопределение пользователя',
      userSublabel: 'Индивидуальные условия для клиента',
      userTooltip: 'Наивысший приоритет. Любое поле здесь перекрывает всё остальное. Используйте для VIP-клиентов, ограниченных счетов или особых условий.',
      userFallsTo: 'Группа счетов (P2)',
      accountGroup: 'Группа счетов',
      groupSublabel: 'Уровни VIP, стандарт, профессионал',
      groupTooltip: 'Применяется ко всем клиентам группы. Если нет переопределения пользователя, применяются настройки группы. Отлично для многоуровневых типов счетов.',
      groupFallsTo: 'Настройки символа (P3)',
      symbolSettings: 'Настройки символа',
      symbolSublabel: 'Конфигурация брокера по инструменту',
      symbolTooltip: 'Управляет правилами ценообразования и исполнения по инструменту. Напр., XAUUSD имеет другую надбавку к спреду, чем EURUSD.',
      symbolFallsTo: 'Платформенные настройки (P4)',
      platformDefaults: 'Платформенные настройки',
      platformSublabel: 'Системный резерв и жёсткие ограничения',
      platformTooltip: 'Наименьший приоритет для значений по умолчанию, но применяет абсолютные жёсткие ограничения, которые не может перекрыть ни один слой. Управляется только системным администратором.',
    },
    setByBroker: 'Задаётся брокером',
    setBySystemAdmin: 'Задаётся системным администратором',
    goToClients: 'Перейти к клиентам',
    goToAccountGroups: 'Перейти к группам счетов',
    goToInstruments: 'Перейти к инструментам',
    fields: {
      maxLeverage: 'Максимальное плечо',
      maxLotSize: 'Максимальный лот',
      marginCallLevel: 'Уровень маржин-колл',
      stopOutLevel: 'Уровень стоп-аут',
      maxOpenPositions: 'Макс. открытых позиций',
      commissionPerLot: 'Комиссия за лот',
      tradingDisabled: 'Торговля отключена',
      spreadMarkup: 'Надбавка к спреду',
      swapMarkup: 'Надбавка к свопу',
      tripleSwapDay: 'День тройного свопа',
      stopLevel: 'Уровень стоп',
      freezeLevel: 'Уровень заморозки',
      defaultLeverage: 'Плечо по умолчанию',
      defaultCommission: 'Комиссия по умолчанию',
      defaultMarginCall: 'Маржин-колл по умолчанию',
      defaultStopOut: 'Стоп-аут по умолчанию',
      maxLeverageCap: 'Потолок макс. плеча',
      minMarginCall: 'Минимальный маржин-колл',
      minStopOut: 'Минимальный стоп-аут',
      maxCommissionCap: 'Потолок комиссии',
      maxPositionsCap: 'Потолок позиций',
    },
    fieldDescs: {
      capLeverageClient: 'Ограничить плечо для конкретного клиента',
      limitPositionSize: 'Ограничить размер позиции за сделку',
      overrideAlertThreshold: 'Переопределить порог оповещения',
      overrideAutoClose: 'Переопределить порог автозакрытия',
      limitConcurrentTrades: 'Ограничить одновременные сделки',
      customCommission: 'Пользовательская комиссия (напр. VIP = 0)',
      killSwitch: 'Экстренный выключатель для клиента',
      groupCommission: 'Комиссия для всей группы',
      groupLeverage: 'Ограничение плеча группы',
      groupMarginCall: 'Порог оповещения группы',
      groupStopOut: 'Порог автозакрытия группы',
      groupPositions: 'Лимит позиций группы',
      groupLotSize: 'Лимит размера сделки группы',
      pipsAddedSpread: 'Пипсы, добавленные к сырому спреду',
      symbolCommission: 'Комиссия по символу',
      overnightSwap: 'Добавляется к ночным ставкам свопа',
      tripleSwapDay: 'День начисления тройного свопа',
      symbolLeverage: 'Ограничение плеча символа',
      symbolLotSize: 'Лимит размера сделки символа',
      minSlTpDistance: 'Мин. расстояние СЛ/ТП в пипсах',
      modificationFreeze: 'Расстояние заморозки изменения',
      fallbackLeverage: 'Резерв, если ни один слой не задан',
      fallbackCommission: 'Резервная ставка комиссии',
      fallbackMarginCall: 'Резервный уровень оповещения',
      fallbackStopOut: 'Резервный уровень автозакрытия',
      hardCeilingLeverage: 'Жёсткий потолок — ни один слой не может превысить',
      hardFloorMarginCall: 'Жёсткий пол — ни один слой не может опуститься ниже',
      hardFloorStopOut: 'Жёсткий пол — ни один слой не может опуститься ниже',
      hardCeilingCommission: 'Жёсткий потолок комиссии',
      systemPositionLimit: 'Системный лимит позиций',
    },
  },

  emailTemplates: {
    loadingTemplates: 'Загрузка шаблонов email…',
    loadingTemplate: 'Загрузка шаблона…',
    retry: 'Повторить',
    allTemplates: '← Все шаблоны',
    customised: 'Изменён',
    custom: 'Пользовательский',
    default: 'По умолчанию',
    subjectLine: 'Тема письма',
    subjectPlaceholder: 'Тема письма…',
    editorTab: 'Редактор',
    htmlTab: 'HTML',
    previewTab: 'Предпросмотр',
    variables: 'Переменные:',
    showLess: 'Показать меньше',
    clickToInsert: 'Нажмите для вставки переменной:',
    saveTemplate: 'Сохранить шаблон',
    savingTemplate: 'Сохранение…',
    resetToDefault: 'Сбросить до стандартного',
    resetting: 'Сброс…',
    back: 'Назад',
    resetConfirm: 'Сбросить до стандартного премиум-шаблона? Ваши изменения будут потеряны.',
    subjectBodyRequired: 'Тема и тело письма обязательны',
    activeBranding: 'Активный брендинг',
    companyName: 'Название компании',
    primaryColor: 'Основной цвет',
    logoUrl: 'URL логотипа',
    noLogoSet: 'Логотип не задан',
    emailFooter: 'Подвал письма',
    brandingNote: 'Для обновления брендинга перейдите в Настройки брокера. Изменения автоматически применяются ко всем шаблонам.',
    editBranding: 'Редактировать брендинг',
    closeBranding: 'Закрыть брендинг',
    templateListDesc: 'Нажмите на шаблон для редактирования. Изменённые шаблоны перекрывают стандартные премиум-шаблоны.',
    templateInfoNote: 'Шаблоны с пометкой "По умолчанию" используют встроенный премиум-дизайн с применением вашего брендинга. Нажмите на любой шаблон для настройки. Используйте "Сбросить до стандартного" в редакторе для отмены изменений.',
    loadingBranding: 'Загрузка брендинга…',
    typeDepositApproved: 'Пополнение одобрено',
    typeDepositRejected: 'Пополнение отклонено',
    typeWithdrawalApproved: 'Вывод одобрен',
    typeWithdrawalRejected: 'Вывод отклонён',
    typeMarginCall: 'Маржин-колл',
    typeLiquidation: 'Счёт ликвидирован',
    typeKycApproved: 'KYC одобрен',
    typeKycRejected: 'KYC отклонён',
    typeWelcome: 'Приветственное письмо',
  },

  credits: {
    activeRules: 'Активные правила',
    totalAwarded: 'Всего начислено',
    awardEvents: 'События начисления',
    bonusRules: 'Правила бонусов',
    awardHistory: 'История начислений',
    newRule: 'Новое правило',
    manualAward: 'Ручное начисление',
    noBonusRules: 'Правил бонусов пока нет. Добавьте одно для автоматического начисления кредита при пополнениях.',
    noCreditAwards: 'Начислений кредита пока нет.',
    deactivateConfirm: 'Деактивировать это правило?',
    revokeReason: 'Причина отзыва (необязательно):',
    operationFailed: 'Операция не выполнена',
    bonusRuleTitle: 'Правило бонуса {mode}',
    ruleName: 'Название правила (напр. Приветственный бонус)',
    percentOfDeposit: '% от пополнения (напр. 20)',
    fixedAmountUsd: 'Фиксированная сумма (USD)',
    maxCreditCap: 'Максимальный лимит кредита (необязательно)',
    minDepositQualify: 'Минимальное пополнение для участия',
    expiresAfterDays: 'Истекает через N дней (необязательно)',
    ruleActive: 'Активно — начисляется автоматически при квалифицирующих пополнениях',
    ruleDisabled: 'Отключено',
    savingDots: 'Сохранение…',
    awardingDots: 'Начисление…',
    manualCreditAward: 'Ручное начисление кредита',
    accountId: 'ID счёта',
    userId: 'ID пользователя',
    amountUsd: 'Сумма (USD)',
    notesOptional: 'Примечания (необязательно)',
    awardCredit: 'Начислить кредит',
    infoWelcomeDeposit: 'Правила ПРИВЕТСТВЕННЫЙ и ДЕПОЗИТ срабатывают автоматически при одобрении пополнения. GOODWILL и АКЦИЯ начисляются вручную. Кредит списывается при ликвидации.',
    bonusWelcome: 'Приветственный',
    bonusDeposit: 'Депозит',
    bonusGoodwill: 'Goodwill',
    bonusPromotion: 'Акция',
    statusRevoked: 'Отозван',
    statusExpired: 'Истёк',
  },

  pages: {
    websitePages: 'Страницы сайта',
    websitePagesDesc: 'Создавайте и управляйте вашим сайтом.',
    pluginNotActive: 'Плагин не активен.',
    viewPlugins: 'Просмотр плагинов',
    mainPages: 'Основные страницы',
    legalPages: 'Юридические страницы',
    langs: 'языки',
    save: 'Сохранить',
    saved: 'Сохранено',
    error: 'Ошибка',
    publish: 'Опубликовать',
    unpublish: 'Снять с публикации',
    published: 'Опубликовано',
    draft: 'Черновик',
    tabBlocks: 'Блоки',
    tabSeo: 'SEO',
    addBlock: 'Добавить блок',
    addFirstBlock: 'Добавить первый блок',
    addFirstBlockHint: 'Добавьте первый блок контента',
    noBlocks: 'Блоков пока нет',
    pageTitle: 'Заголовок страницы',
    pageTitleHint: 'Основной заголовок страницы, отображаемый в навигации и шапке',
    translatable: 'Переводимо',
    pageSlug: 'Слаг страницы',
    seoTitle: 'SEO-заголовок',
    seoDescription: 'SEO-описание',
    googlePreview: 'ПРЕДПРОСМОТР GOOGLE',
    noDescription: 'Описание отсутствует.',
    catHeroLayout: 'Главный экран и макет',
    catContent: 'Контент',
    catFeaturesData: 'Возможности и данные',
    catSocialProof: 'Социальное доказательство',
    catCta: 'Призыв к действию',
    catDocuments: 'Документы и юридические',
    catOther: 'Прочее',
    missing: 'Отсутствует',
    add: 'Добавить',
    addItem: 'Добавить элемент',
    item: 'Элемент',
    notStarted: 'Не начато',
  },

  userOverride: {
    title: 'Переопределение счёта пользователя',
    infoBannerTitle: 'Переопределения на уровне пользователя (Слой 1)',
    infoBannerDesc: 'Эти настройки перекрывают настройки группы счёта пользователя. Оставьте поля пустыми (NULL) для использования настроек группы.',
    sectionTradingControl: 'Управление торговлей',
    sectionRiskParameters: 'Параметры риска',
    sectionPricingOverrides: 'Переопределения цен',
    disableTrading: 'Отключить торговлю',
    disableTradingSubLabel: 'Запретить пользователю открывать новые позиции',
    resetToGroupDefault: 'Сбросить до стандарта группы',
    groupDefault: 'Стандарт группы',
    maxLeverage: 'Максимальное плечо',
    maxLotSize: 'Максимальный лот',
    minLotSize: 'Минимальный лот',
    marginCallLevel: 'Уровень маржин-колл (%)',
    stopOutLevel: 'Уровень стоп-аут (%)',
    maxOpenPositions: 'Макс. открытых позиций',
    commissionPerLot: 'Комиссия за лот (USD)',
    commissionPerLotHint: 'USD за каждый стандартный лот',
    minAboveMaxError: '⚠️ Минимальный лот не может превышать максимальный',
    currentOverrideTitle: 'Активное переопределение',
    currentOverrideDesc: 'У этого пользователя есть индивидуальные настройки, перекрывающие настройки группы.',
    saveOverride: 'Сохранить переопределение',
    saving: 'Сохранение...',
    saveSuccess: 'Переопределение пользователя успешно сохранено',
    saveFailed: 'Не удалось сохранить переопределение',
    lots: 'лотов',
    lotStep: 'Шаг лота',
  },

  symbolSettings: {
    sectionPricing: 'Ценообразование брокера',
    sectionRisk: 'Лимиты риска',
    sectionExecution: 'Правила исполнения',
    sectionOverrides: 'Переопределения инструмента',
    sectionsLabel: 'Разделы',
    pricingDesc: 'Корректировки, применяемые поверх сырых ставок инструмента для этого брокера.',
    riskDesc: 'Лимиты позиций и плеча на уровне брокера.',
    executionDesc: 'Ограничения на размещение и изменение ордеров.',
    overridesDesc: 'Переключайте каждое поле для активации переопределения на уровне брокера. Отключённые поля используют общую таблицу инструментов.',
    overridesInfoTitle: 'Своп Long / Своп Short',
    overridesInfoDesc: 'при включении полностью заменяют ставку инструмента — надбавка к свопу не добавляется сверху. Все остальные переопределения каскадируются обычным образом.',
    settingsTitle: 'Настройки {symbol}',
    headerSubtitle: 'Настроить ценообразование и риск на уровне брокера (Слой 3)',
    overrideActive: '{count} переопределение активно',
    overridesActive: '{count} переопределений активно',
    spreadMarkup: 'Надбавка к спреду',
    spreadMarkupHint: 'Пипсы, добавленные к сырому спреду от поставщика ликвидности',
    commissionPerLot: 'Комиссия за лот',
    commissionPerLotHint: 'USD за каждый стандартный лот',
    swapMarkup: 'Надбавка к свопу',
    swapMarkupHint: 'Пункты, добавляемые к ставкам свопа инструмента. Игнорируется при включённых swap_long / swap_short.',
    tripleSwapDay: 'День тройного свопа',
    tripleSwapDayHint: 'День начисления тройного свопа',
    maxLeverage: 'Максимальное плечо',
    maxLeverageHint: 'Максимальное плечо для этого символа',
    maxLotSize: 'Максимальный лот',
    maxLotSizeHint: 'Максимальный размер позиции за сделку',
    minLotSize: 'Минимальный лот',
    minLotSizeHint: 'Минимальный размер позиции за сделку',
    minAboveMaxError: '⚠️ Минимальный лот не может превышать максимальный',
    stopLevel: 'Уровень стоп',
    stopLevelHint: 'Минимальное расстояние СЛ/ТП от текущей цены (пипсы)',
    freezeLevel: 'Уровень заморозки',
    freezeLevelHint: 'Расстояние, при котором изменение ордеров замораживается (пипсы)',
    contractSize: 'Размер контракта',
    contractSizeHint: 'Единиц на лот. Напр. 100000 для стандартного форекс, 1 для акций.',
    priceScale: 'Шкала цены',
    priceScaleHint: 'Знаков после запятой. 5 = 1.23456, 2 = 1.23.',
    swapLong: 'Своп Long (прямая ставка)',
    swapLongHint: 'Ночная ставка для позиций на покупку. Полностью заменяет ставку инструмента.',
    swapShort: 'Своп Short (прямая ставка)',
    swapShortHint: 'Ночная ставка для позиций на продажу. Полностью заменяет ставку инструмента.',
    swapMode: 'Режим свопа',
    swapModeHint: 'Метод расчёта ночной ставки свопа',
    maxVolume: 'Макс. объём (лоты)',
    maxVolumeHint: 'Максимальный размер одной сделки в лотах для этого брокера.',
    volumeStep: 'Шаг объёма (лоты)',
    volumeStepHint: 'Минимальный шаг размера сделки. Напр. 0.01 допускает 0.01, 0.02, 0.03…',
    defaultBadge: 'по умолчанию',
    pips: 'пипсы',
    pts: 'пунктов',
    lots: 'лотов',
    decimals: 'знаков',
    dayMon: 'Пн',
    dayTue: 'Вт',
    dayWed: 'Ср',
    dayThu: 'Чт',
    dayFri: 'Пт',
    daySat: 'Сб',
    daySun: 'Вс',
    loadingSettings: 'Загрузка настроек…',
    saveSettings: 'Сохранить настройки',
    lotStep: 'Шаг лота',
  },

  accountGroupForm: {
    sectionsLabel: 'Разделы',
    sectionBasic: 'Основная информация',
    sectionPricing: 'Переопределения цен',
    sectionRisk: 'Управление рисками',
    editTitle: 'Редактировать группу счетов',
    createTitle: 'Создать группу счетов',
    basicInfoTitle: 'Основная информация',
    groupNameLabel: 'Название группы *',
    groupNamePlaceholder: 'Стандартная группа',
    descriptionLabel: 'Описание',
    descriptionPlaceholder: 'Описание группы...',
    groupActive: 'Группа активна',
    defaultGroup: 'Группа по умолчанию',
    pricingTitle: 'Переопределения цен',
    pricingDesc: 'Оставьте пустым для использования настроек брокера. Задавайте только если группе нужно другое ценообразование.',
    commissionPerLot: 'Комиссия за лот (USD)',
    commissionPerLotHint: 'USD за каждый стандартный лот',
    maxLeverage: 'Максимальное плечо',
    maxLeverageHint: 'Максимальное доступное плечо для группы',
    brokerDefault: 'Стандарт брокера',
    resetToNoLimit: 'Сбросить — без ограничений',
    riskTitle: 'Управление рисками',
    marginCallLevel: 'Уровень маржин-колл',
    marginCallHint: 'Оповещение при достижении уровня маржи',
    stopOutLevel: 'Уровень стоп-аут',
    stopOutHint: 'Автозакрытие позиций на этом уровне маржи',
    maxOpenPositions: 'Макс. открытых позиций',
    maxOpenPositionsHint: 'Максимальное количество позиций на счёт',
    maxLotSize: 'Максимальный лот',
    maxLotSizeHint: 'Максимальный размер лота за сделку',
    minLotSize: 'Минимальный лот',
    minLotSizeHint: 'Минимальный размер лота для группы',
    noLimit: 'Без ограничений',
    lots: 'лотов',
    marginBelowStopError: '⚠️ Уровень маржин-колл должен быть выше уровня стоп-аут',
    minAboveMaxError: '⚠️ Минимальный лот не может превышать максимальный',
    updateGroup: 'Обновить группу',
    createGroup: 'Создать группу',
    lotStep: 'Шаг лота',
  },

  cryptoCheckout: {
    paymentConfirmedTitle: 'Платёж подтверждён!',
    makePayment: 'Оплатить',
    depositFunds: 'Пополнить счёт',
    purchaseItem: 'Купить {name}',
    subscribeTo: 'Подписаться на {name}',
    selectPaymentMethod: 'Выберите способ оплаты',
    payWith: 'Оплатить через {currencies}',
    creatingPayment: 'Создание платежа...',
    continue: 'Продолжить',
    sendExactly: 'Отправить точно',
    approxUsd: '≈ ${amount} USD',
    hideQrCode: 'Скрыть QR-код',
    showQrCode: 'Показать QR-код',
    scanWithWallet: 'Отсканируйте мобильным кошельком',
    toThisAddress: 'На этот адрес {network}',
    expiresIn: 'Истекает через',
    waitingForPayment: 'Ожидание платежа...',
    waitingDesc: 'Отправьте точную сумму. Мы определим автоматически.',
    verifiedOnChain: 'Проверено в блокчейне AmorPay. Без посредников.',
    pluginActivated: '{name} активирован.',
    depositCredited: 'Ваш депозит зачислен на счёт.',
    subscriptionActive: 'Ваша подписка активна.',
    paymentConfirmed: 'Ваш платёж подтверждён.',
    done: 'Готово',
    noItemSelected: 'Элемент для покупки не выбран',
    failedToLoadOptions: 'Не удалось загрузить варианты оплаты',
  },

  subscriptionGate: {
    accountSuspended: 'Аккаунт приостановлен',
    subscriptionExpired: 'Подписка истекла',
    suspendedDesc: 'Ваш аккаунт был приостановлен. Обратитесь в поддержку для восстановления доступа.',
    expiredDesc: 'Срок вашей подписки {plan} истёк и льготный период завершён. Продлите для восстановления полного доступа.',
    renewSubscription: 'Продлить подписку',
    signOut: 'Выйти',
    needHelp: 'Нужна помощь? Обратитесь в',
    lastChance: '⚠️ Последний шанс! Ваша подписка {plan} истекла. Доступ заканчивается сегодня.',
    gracePeriodDay: 'Ваша подписка {plan} истекла. В льготном периоде осталось {days} день.',
    gracePeriodDays: 'Ваша подписка {plan} истекла. В льготном периоде осталось {days} дней.',
    renewNow: 'Продлить сейчас',
  },

  upgradePage: {
    renewTitle: 'Продление подписки',
    upgradeTitle: 'Обновить план',
    currentlyOn: 'Текущий план',
    graceDaysLeft: 'Осталось {days} день льготного периода',
    graceDaysLeftPlural: 'Осталось {days} дней льготного периода',
    expired: 'Истёк',
    graceWarning: 'Ваша подписка истекла. У вас есть {days} день для продления до блокировки аккаунта.',
    graceWarningPlural: 'Ваша подписка истекла. У вас есть {days} дней для продления до блокировки аккаунта.',
    expiredWarning: 'Срок вашей подписки полностью истёк. Продлите сейчас для восстановления доступа.',
    renewOrUpgrade: 'Вы можете продлить текущий план или перейти на более высокий уровень.',
    monthly: 'Ежемесячно',
    yearly: 'Ежегодно',
    mostPopular: 'Самый популярный',
    currentPlan: 'Текущий план',
    perMonth: '/мес',
    saveYearly: 'Скидка 10% — ${amount}/год',
    unlimitedTraders: 'Неограниченно трейдеров',
    tradersCount: '{count} трейдеров',
    unlimitedAdmins: 'Неограниченно администраторов',
    adminsCount: '{count} администраторов',
    unlimitedInstruments: 'Неограниченно инструментов',
    instrumentsCount: '{count} инструментов',
    feedUltra: 'Сверхнизкая задержка котировок',
    feedPriority: 'Приоритетные котировки',
    feedStandard: 'Стандартные котировки',
    fullApiAccess: 'Полный доступ к API',
    selected: 'Выбрано',
    selectPlan: 'Выбрать план',
    fullComparison: 'Полное сравнение',
    featureCol: 'Возможность',
    featureTraders: 'Трейдеры',
    featureAdmins: 'Администраторы',
    featureInstruments: 'Инструменты',
    featureFeedLatency: 'Задержка котировок',
    featureApiAccess: 'Доступ к API',
    featureForex: 'Форекс',
    featureCrypto: 'Крипто',
    featureCommodities: 'Товары',
    featureIndices: 'Индексы',
    featureStocks: 'Акции',
    selectedPlan: 'Выбрано:',
    selectToContinue: 'Выберите план для продолжения',
    perYear: '/год',
    renewNow: 'Продлить сейчас',
    upgradeNow: 'Обновить сейчас',
    failedToLoadPlans: 'Не удалось загрузить планы',
    selectPlanFirst: 'Сначала выберите план',
    planActivated: 'План {name} активирован! 🎉',
  },

  sidebar: {
    sectionOverview: 'Обзор',
    sectionManagement: 'Управление',
    sectionTrading: 'Торговля',
    sectionFinance: 'Финансы',
    sectionPlugins: 'Плагины',
    sectionSystem: 'Система',
    accountGroups: 'Группы счетов',
    cascadeGuide: 'Руководство по каскаду',
    pluginStore: 'Магазин плагинов',
    kycVerification: 'Верификация KYC',
    kycDashboard: 'Панель KYC',
    kycConfig: 'Настройка KYC',
    pages: 'Страницы',
    credits: 'Кредиты',
    emailTemplates: 'Шаблоны писем',
    restApi: 'REST API',
    advancedAnalytics: 'Расширенная аналитика',
    descClients: 'Пользователи · Настройки · Переопределения',
    descGroups: 'Группы · Настройки · Переопределения',
    descInstruments: 'Брокер · Настройки · Переопределения',
    descAccounts: 'Счета и балансы',
    descCascade: 'Система приоритетов объяснена',
    descAnalytics: 'Аналитика на основе ИИ',
    badgeLive: 'Прямой эфир',
    badgeActive: 'Активен',
    badgeAddon: 'Расширение',
    badgePro: 'PRO',
    badgeApi: 'API',
    badgeConfig: 'Конфиг',
    badgeHowItWorks: 'Как это работает',
    cascadeTipFallthrough: 'Оставьте поля пустыми для перехода к следующему уровню',
  },

};